import React from 'react';
import './Skeleton.css';

const Skeleton: React.FC<{ rows?: number }> = ({ rows = 5 }) => (
  <div className="dashboard-skeleton">
    {Array.from({ length: rows }).map((_, i) => (
      <div className="dashboard-skeleton-row" key={i} />
    ))}
  </div>
);

export default Skeleton;
